<template>
  <a-dialog v-model="show" max-width="700px" persist>
    <span
      slot="header"
      v-t="'Security.UserImpersonation.Impersonation'"
      class="headline"
    />
    <div
      slot="body"
      v-t="'Security.UserImpersonation.ImpersonationDescription'"
    />
    <div slot="footer">
      <button
        v-t="'Security.UserImpersonation.ImpersonationAbort'"
        class="btn btn-pf-secondary"
        @click="hideDialog"
      />
      <button
        v-t="'Security.UserImpersonation.ImpersonationExecute'"
        class="btn btn-pf-primary ms-2"
        @click="performImpersonate()"
      />
    </div>
  </a-dialog>
</template>

<script>
import Dialog from "+/components/dialog/Dialog";

export default {
  components: {
    "a-dialog": Dialog
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    performImpersonate() {
      this.$rest.security
        .performImpersonate(this.user.id)
        .then((response) => {
          location.href = "/";
        })
        .catch(this.impersonationException);
    },
    impersonationException() {
      const error = this.$t(
        "Security.UserImpersonation.ImpersonationException"
      );
      this.$feedback(error, { type: "error" });
    },
    hideDialog() {
      this.show = false;
    }
  }
};
</script>
